import React from 'react';
import { useIntl } from 'react-intl';
import { Grid } from '@material-ui/core';
import { CalculatorSummarySectionProps } from 'modules/BusinessTrips/types';
import {
  DataTypeTitle,
  SummarySectionContainer,
  SummarySectionTitle,
} from '../BusinessTripCalculator.css';

const SummarySection = ({
  businessTripSectionData,
  title,
  data,
}: CalculatorSummarySectionProps) => {
  const intl = useIntl();
  return (
    <SummarySectionContainer>
      {businessTripSectionData.map((el, key) => {
        if (!el.content) {
          return null;
        }
        return (
          <Grid
            container
            direction="row"
            key={`${key}-${el.name}`}
            justify="space-between"
          >
            <DataTypeTitle item>
              {intl.formatMessage({
                id: el.name,
              })}
              :
            </DataTypeTitle>
            <Grid item>
              {el.content
                ? el.content
                : intl.formatMessage({ id: 'SUMMARY.NONE' })}
            </Grid>
          </Grid>
        );
      })}
      <SummarySectionTitle>
        {intl.formatMessage(
          {
            id: title,
          },
          { currency: data },
        )}
      </SummarySectionTitle>
    </SummarySectionContainer>
  );
};

export default SummarySection;
